import { render, staticRenderFns } from "./NotificationRecipientsList.vue?vue&type=template&id=adfd77d8&scoped=true&lang=pug"
import script from "./NotificationRecipientsList.vue?vue&type=script&lang=js"
export * from "./NotificationRecipientsList.vue?vue&type=script&lang=js"
import style0 from "./NotificationRecipientsList.vue?vue&type=style&index=0&id=adfd77d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfd77d8",
  null
  
)

export default component.exports